import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const loginApi = (payload) => {
  return apiCall({
    method: 'post',
    payload,
    endpoint: apiEndpoints.UNIFIED_LOGIN,
    isAuthEndPoint: true,
    customOrigin: process.env.REACT_APP_SELF_SERVE_BASE_URL,
  });
};

export const newSignUpApi = (payload: {
  NewPassword: string;
  Token: string;
}): void => {
  return apiCall({
    method: 'post',
    payload,
    endpoint: apiEndpoints.UNIFIED_NEW_SIGN_UP,
    isAuthEndPoint: true,
  });
};

export const logOutApi = (): void => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.LOGOUT,
    isAuthEndPoint: true,
  });
};

export const refreshTokenApi = (): void => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.UNIFIED_REFRESH_TOKEN,
    isAuthEndPoint: true,
  });
};

export const changePasswordApi = (data: {
  CurrentPassword: string;
  NewPassword: string;
}): void => {
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.CHANGE_PASSWORD,
    isAuthEndPoint: true,
  });
};

export const saveNewPasswordApi = (data: {
  NewPassword: string;
  otpToken: string;
}): void => {
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.UNIFIED_SAVE_NEW_PASSWORD,
    isAuthEndPoint: true,
  });
};

export const UserEnvApi = (data: { EmailId: string }): void => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_USER_ENV(data.EmailId),
    isAuthEndPoint: true,
  });
};

export const forgetPasswordApi = (data: { EmailId: string }): void => {
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.UNIFIED_FORGET_PASSWORD,
    isAuthEndPoint: true,
  });
};

export const validateOtpApi = (data: {
  otpToken: string;
  otpValue: string | number;
}): void => {
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.UNIFIED_VALIDATE_OTP,
    isAuthEndPoint: true,
    customOrigin: process.env.REACT_APP_SELF_SERVE_BASE_URL
  });
};

export const updateMerchantTRMStatus = (data: {
  status: boolean;
  MerchantId: number;
}): void => {
  return apiCall({
    method: 'put',
    payload: data,
    endpoint: apiEndpoints.UPDATE_MERCHANT_TRM_STATUS,
  });
};

export const clientSecretKeyApi = (): void => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_CLIENT_SECRET_KEY,
  });
};

export const verifyCaptchaApi = (data: { captchaResponse: string }): void => {
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.UNIFIED_VERIFY_CAPTCHA_API,
  });
};

export const getTRMRedirectUrlApi = (): void =>
  apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_TRM_REDIRECT_URL,
  });

export const validateInvitationApi = (data: {
  token: string;
  isAdmin: boolean;
}): any => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_VALIDATE_REGISTER_TOKEN(
      data.token,
      data.isAdmin
    ),
  });
};

export const fetchLoginOtpApi = (data: {
  email: string;
  isAdmin: boolean;
  type: string;
}): any => {
  const { email, isAdmin } = data;
  const payload = { email, isAdmin };
  const base64payload = btoa(JSON.stringify(payload));
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_FETCH_LOGIN_OTP,
    query: {
      payload: base64payload,
    },
  });
};

export const validateLoginOtpApi = (data: {
  email: string;
  isAdmin: boolean;
  otp: string;
  otpToken: string;
}): any => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.UNIFIED_VALIDATE_LOGIN_OTP,
    payload: data,
  });
};

export const fetchMerchantApi = (data:{
  merchantId: string | number;
  email: string;
  partnerFilter?: {
    isPartnerMerchant: boolean;
    partnerMerchantId: string;
  };
}):any => {

   const url = apiEndpoints.UNIFIED_FETCH_MERCHANT(data.merchantId, data.email);

   const query: Record<string, any> = {};

   if (data.partnerFilter) {
    query.partnerFilter = JSON.stringify(data.partnerFilter);
   }
   
  
  return apiCall({
    method: 'get',
    endpoint: url,
    query,
    payload: data,
  });
};

export const resendEmailApi = (data: {
  email: string;
  id: string;
}):any => {  
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.RESEND_EMAIL,
    payload: data,
  });
};

export const newUserApi = (data:{
  merchantId: string | number;
  email: string;
}):any => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.NEWUSER(data.merchantId, data.email),
    payload: data,
  });
};

export const getMerchantDetialsApi = (data: { merchantId: string }): void => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_MERCHANT_DETIALS(data.merchantId),
  });
};
export const getPartnerMerchantDetialsApi = (data: { merchantId: string, isParentToChild: any }): any => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_PARTNER_MERCHANT_DETAILS(data.merchantId, data.isParentToChild),
  });
};

